<template>
  <div ref="content" class="listing-details-pdf">
    <div v-if="readyToLoadDetails" class="pdf-content">
      <Page1 :listing="listing" />
      <Page2 :listing="listing" />
      <Page3 :listing="listing" />
      <Page4 :listing="listing" />
      <Page5 :listing="listing" />
      <Page6 :listing="listing" />
      <Page7 />
      <Page8 />
      <Page9 />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dateformat from 'dateformat'
import appUrls from '../helpers/environment'

import Page1 from './buyer-listing-details-as-pdf/PdfPage1'
import Page2 from './buyer-listing-details-as-pdf/PdfPage2'
import Page3 from './buyer-listing-details-as-pdf/PdfPage3'
import Page4 from './buyer-listing-details-as-pdf/PdfPage4'
import Page5 from './buyer-listing-details-as-pdf/PdfPage5'
import Page6 from './buyer-listing-details-as-pdf/PdfPage6'
import Page7 from './buyer-listing-details-as-pdf/PdfPage7'
import Page8 from './buyer-listing-details-as-pdf/PdfPage8'
import Page9 from './buyer-listing-details-as-pdf/PdfPage9'

export default {
  name: 'ListingDetail',
  components: {
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Page7,
    Page8,
    Page9
  },

  props: {
    id: String,
  },

  data () {
    return {
      readyToLoadDetails: false,
      listing: {},
      listing_statuses: [
        {
          value: 1,
          text: 'Open',
          filter: 'open_listings'
        },
        {
          value: 2,
          text: 'Coming Soon',
          filter: 'coming_listings'
        },
        {
          value: 3,
          text: 'Pending',
          filter: 'pending_listings'
        },
        {
          value: 4,
          text: 'Sold',
          filter: 'sold_listings'
        },
      ],

      externalElementsToHide: [
        '#hubspot-messages-iframe-container',
      ],
    }
  },

  async mounted () {
    await this.getLists()
    await this.getListingDetail()

    for (const elQuery of this.externalElementsToHide) {
      const el = document.querySelector(elQuery)
      if (!el) return

      el.style.setProperty('display', 'none', 'important')
    }
  },

  beforeDestroy () {
    for (const elQuery of this.externalElementsToHide) {
      const el = document.querySelector(elQuery)
      if (!el) return

      el.style.setProperty('display', '')
    }
  },

  methods: {
    async getListingDetail () {
      try {
        const response = await axios.post(
          `${appUrls.api}/api/listing_detail_pdf_view/${this.id}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )

        if (!response.data.outcome) return

        const formatted = this.formatListing(response.data.listing, response.data)
        this.listing = formatted
      } catch (error) {
        console.log(error)
      }

      this.readyToLoadDetails = true
    },

    formatListing (listing, responseData) {
      // Misc
      listing.post_date = dateformat(listing.post_date, "mm/dd/yyyy")
      listing.listing_type = parseInt(listing.listing_type)
      listing.status = parseInt(listing.status)
      listing.revenue_t12_asof_date = dateformat(listing.revenue_t12_asof_date, "mmmm dd, yyyy")

      listing.t12AsOfYear = dateformat(listing.revenue_t12_asof_date || (new Date()), 'yyyy')

      // Location
      let vLoc = ''
      if (listing.city && listing.state) {
        vLoc = `${listing.city}, ${listing.state}`
      }
      if ((!listing.city && listing.state) || (listing.city && !listing.state)) {
        vLoc = listing.state || listing.city
      }
      listing.location = vLoc

      // header image
      if (listing.custom_image) {
        listing.img = require(`@/assets/listings/custom/${listing.custom_image}`);
      } else {
        listing.img = require(`@/assets/listings/states/${listing.state}.jpg`);
      }

      // listing type
      listing.type_name = this.getListingTypeName(listing.listing_type);

      listing.status_name = this.statusName(listing)

      listing.postDateYear = dateformat(listing.post_date || (new Date()), 'yyyy')

      listing.tamps = listing.company_tamps;

      listing.custodians = listing.company_custodians;

      listing.brokerDealer = listing.company_broker_dealer;

      return listing
    },

    getListingTypeName (type) {
      const listingType = this.listing_types.find(({ value }) => {
        return Number(value) === Number(type)
      })

      return (listingType || {}).text
    },

    async getLists () {
      const optionsLists = [
        {
          name: 'listing_types',
          type: 'int',
        },
        {
          name: 'buyer_status',
          type: 'int',
        },
        {
          name: 'states',
          type: 'txt',
        },
      ]

      try {
        const response = await axios.post(`${appUrls.api}/api/lists`, {
          headers: {
            'Content-Type': 'application/json',
          },
          list_options: optionsLists,
        })

        if (!response.data.outcome) return

        const { lists } = response.data
        // set properties with their appropriate list
        for (const { name, list } of lists) {
          if (name === 'states') this.states = list
          if (name === 'buyer_status') this.buyer_status = list
          if (name === 'listing_types') this.listing_types = list
        }
      } catch (error) {
        console.log(error)
      }
    },

    statusName (listing) {
      if (!this.listing_statuses || !listing) return ''

      return (
        this.listing_statuses.find(({ value }) => parseInt(value) === listing.status) ||
        {}
      ).text || ''
    },
  },
}
</script>

<style>
.listing-details-pdf {
  background-color: #525659;
  width: 100%;
  padding: 0 20px;

  overflow-x: auto;
}

.listing-details-pdf .pdf-content {
  width: 740px;
  margin: auto;
  padding: 20px 0;
}

.pdf-content .page {
  position: relative;

  height: 279.4mm;
  width: 215.9mm;
  margin: 20px auto;
  padding-bottom: 35px;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  background-color: white;
  background-image: url('./buyer-listing-details-as-pdf/assets/background-compass.png');
  background-position: 10px -60px;
  background-size: 500px;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.3);

  counter-increment: pagenum;
}

.pdf-content .page::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;

  background-color: #FFFFFF99;
}

.pdf-content .page > * {
  position: relative;
  z-index: 10;

  flex-grow: 0;
  flex-shrink: 0;
}

.pdf-content .page:after {
  content: counter(pagenum);
  position: absolute;
  bottom: 13px;
  left: 50%;
  z-index: 2;

  font-family: "Sansation", sans-serif;
  font-size: 11pt;
}

.pdf-content .page:first-child:after {
  content: '';
}

.pdf-content .page h1 {
  font-family: "SansationBold", sans-serif;
  font-size: 32pt;
}

.pdf-content .page h2 {
  color: #5F6062;
  font-family: "SansationBold", sans-serif;
  font-size: 22pt;
  line-height: 24pt;
  letter-spacing: 0.8px;
}

.pdf-content .page h3 {
  color: #5F6062;
  font-family: "SansationBold", sans-serif;
  font-size: 16pt;
  letter-spacing: 0.8px;
}

.pdf-content .page p {
  color: #5F6062;
  font-family: "Sansation", sans-serif;
  font-size: 12pt;
  line-height: 15pt;
}

.pdf-content .page .btn {
  min-width: 150px;
  height: 45px;
  padding: 8px 30px;

  display: inline-block;

  background-color: transparent;
  color: black;
  font-family: "SansationBold", sans-serif;
  font-size: 14pt;
  letter-spacing: 0.4px;
  text-align: center;
  text-decoration: none;
}

.pdf-content .page .btn.btn-green {
  background-color: #99CC33;
  color: white;
  /* text-shadow: 0 0 10px rgba(0, 0, 0, 0.3); */
}

.pdf-content .page .btn.btn-blue {
  background-color: #1F8A92;
  color: white;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.pdf-content .page h5 {
  color: #E95542;
  font-family: "Sansation", sans-serif;
  font-size: 12pt;
  font-weight: normal;
  letter-spacing: 3px;
  text-align: center;
  text-transform: uppercase;
  white-space: pre;
}

.pdf-content .page .copyright {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.pdf-content .page .copyright span,
.pdf-content .page .copyright a {
  position: relative;
  color: #5F6062;
  font-family: "Avenir", sans-serif;
  font-size: 10pt;
  text-align: center;
  text-decoration: none;
}

.pdf-content .page .copyright span {
  padding: 0 5px;
}

.pdf-content .page .copyright span:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 3px;
  bottom: 3px;
  right: 0;
  width: 1px;

  background-color: #5F6062AA;
}

.page .page-data-item span,
.page .page-data-item label {
  display: block;
  color: #5F6062;
}

.page .page-data-item img {
  width: 35px;
  margin-left: auto;
}

.page .page-data-item span,
.page .page-data-item.nested label {
  font-family: "SansationBold", sans-serif;
  font-size: 16pt;
  line-height: 18pt;
}

.page .page-data-item label,
.page .page-data-item.nested span {
  font-family: "Sansation", sans-serif;
  font-size: 12pt;
  line-height: 14pt;
}

.page .page-data-item.nested label {
  font-size: 12pt;
  line-height: 14pt;
}

.page .page-data-grid {
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 20px;
}

.page .page-data-item {
  display: grid;
}

.page .data-grid-table {
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 2px;
}

.page .data-grid-table .page-data-item {
  width: 100%;
  display: grid;
  grid-template-columns: auto 40px 1fr;
  grid-auto-rows: 60px;
  grid-column-gap: 10px;
  align-items: center;

  padding: 0 10px;
}

.page .data-grid-table .page-data-item.nested {
  grid-template-columns: auto 1fr;
}

.page .data-grid-table .page-data-item:not(:last-child):not(.no-bottom) {
  border-bottom: 2px solid #F2F2F2;
}

.page .data-grid-table .page-data-item:not(:nth-child(2n)) {
  border-right: 2px solid #F2F2F2;
}

.page .data-grid-table .page-data-item img {
  width: 35px;
}

.page .page-data-card {
  margin: 20px 0;
  padding: 20px;

  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: space-around;

  border: 2px dashed #99CC33;
}

.page .page-data-card-box {
  height: 50px;

  display: flex;
  align-items: center;

  background-color: #97C131;
}

.page .page-data-card-box span {
  flex-grow: 1;

  color: white;
  font-family: "SansationBold", sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.page .box {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

@page {
  size: letter portrait;
  margin: 0;
}

@media print {
  .pdf-content .page {
    margin: 0;
  }

  .listing-details-pdf,
  .listing-details-pdf .pdf-content {
    margin: 0;
    padding: 0;
    background-color: white;
  }

  .pdf-content .page {
    box-shadow: none;

    page-break-after: always;
  }

  header,
  footer {
    display: none !important;
  }

  main {
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ListingDetailAsPdf.vue